<template>
  <div class="wrapper" style="position: relative">
    <!--    <build-button-->
    <!--      style="position: absolute;top: 20px;right: 20px;z-index: 999999;cursor: pointer"-->
    <!--    />-->
    <parallax :style="headerStyle" class="section page-header header-filter">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item">
            <h2 class="title">常州华龙通信科技股份有限公司</h2>
            <h4>
              国内知名的安防光通信设备制造商 |
              专业的智慧警务、数字政法、市域治理的IT服务商
            </h4>
            <br />
          </div>
        </div>
      </div>
    </parallax>
    <module-item v-for="(item, index) in data_json" :key="index" :item="item" />
  </div>
</template>

<script>
// import BuildButton from "@/components/BuildButton.vue";
import data_json from "/data.json";
import ModuleItem from "@/views/components/ModuleItem.vue";

export default {
  components: { ModuleItem },
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/contract.jpg")
    }
  },
  data() {
    return {
      data_json: data_json["module_list"]
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
